import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-actual-skeleton-loader',
  templateUrl: './actual-skeleton-loader.component.html',
  styleUrls: ['./actual-skeleton-loader.component.scss']
})
export class ActualSkeletonLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
